import { $Q } from "../utils/querySelector";

// node top bar sticky element
const stickyElement = $Q(".stickyaddcart");

/**
 * Init observer for add to cart button in product page
 * @author Michael Ballen
 * @see elementIntersect(entries)
 */
const observeStickyAddCart = () => {
  const addToCartButtom = $Q("#main-add-cart");

  if (addToCartButtom != null) {
    const observer = new IntersectionObserver(elementIntersect);

    observer.observe(addToCartButtom);
  }
}

/**
 * Function for the observer in add to cart buttom
 * @param {Array} entries - Entries 
 * @author Michael Ballen
 * @see showStickyElement();
 */
const elementIntersect = (entries) => {

  entries.forEach(entry => {
    showStickyElement(entry.isIntersecting, stickyElement);
  });
}

/**
 * Show or hidde element when is intersecting
 * @param {Boolean} isIntersecting 
 * @param {Node} stickyElement 
 */
const showStickyElement = (isIntersecting, stickyElement) => {
  if (isIntersecting === false && window.scrollY > 80) {
    stickyElement.classList.add("isSticky");
  } else {
    stickyElement.classList.remove("isSticky");
  }
}

const upButton = () => {
  const upPageButton = $Q(".button-up");

  if (upPageButton) {

    if (window.scrollY > 80) {
      upPageButton.classList.remove("hidde");
    } else {
      upPageButton.classList.add("hidde");
    }

  }
}

window.onscroll = () => {
  // observeStickyAddCart();
  upButton();
}
